const steps = [
  {
    num: '01',
    icon: 'ri-phone-line',
    title: 'Call or Request Online',
    desc: 'Reach us at 770.236.1255 or submit the estimate form. We discuss your needs and provide a transparent, no-obligation quote.',
  },
  {
    num: '02',
    icon: 'ri-map-pin-2-line',
    title: 'On-Site Assessment',
    desc: 'A certified technician visits your home or business to measure, inspect, and confirm the best plan for your floors.',
  },
  {
    num: '03',
    icon: 'ri-tools-fill',
    title: 'Expert Service Delivered',
    desc: 'Our trained professionals execute the work with professional-grade equipment and proven techniques — on time, every time.',
  },
  {
    num: '04',
    icon: 'ri-shield-check-line',
    title: 'Guaranteed Results',
    desc: 'We inspect every job before we leave. Not 100% satisfied? We return and re-service absolutely free. No fine print.',
  },
];

export default function Process() {
  return (
    <section id="process" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        <div className="text-center mb-16">
          <p className="text-amber-600 text-[11px] font-bold tracking-[0.25em] uppercase mb-3">How It Works</p>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mb-4">Our Proven Process</h2>
          <div className="w-16 h-px bg-amber-500 mx-auto mb-5"></div>
          <p className="text-stone-500 text-lg max-w-lg mx-auto">
            Simple, transparent, and built around your schedule — from first call to final inspection.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector */}
          <div className="hidden lg:block absolute top-[52px] left-[calc(12.5%+32px)] right-[calc(12.5%+32px)] h-px border-t border-dashed border-stone-200 z-0"></div>

          {steps.map((step) => (
            <div key={step.num} className="relative z-10 flex flex-col items-center text-center">
              {/* Circle */}
              <div className="relative mb-7">
                <div className="w-[104px] h-[104px] rounded-full border border-stone-200 bg-white flex items-center justify-center">
                  <span className="font-serif text-4xl font-bold text-stone-200">{step.num}</span>
                </div>
                <div className="absolute -bottom-2 -right-2 w-9 h-9 flex items-center justify-center bg-amber-600 rounded-full text-white">
                  <i className={`${step.icon} text-sm`}></i>
                </div>
              </div>
              <h3 className="text-stone-900 font-bold text-base mb-3 leading-snug">{step.title}</h3>
              <p className="text-stone-500 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a
            href="#estimate-form"
            className="inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold text-sm px-9 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            Start With a Free Estimate
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
